export type Meta = {
  title: string;
  description?: string;
  image?: string;
  icon?: string;
  category?: string;
};

export const fetchMeta = async (url: string): Promise<Meta> => {
  const res = await fetch(
    `https://apiv2.app.aula.education/meta/scrap?url=${encodeURIComponent(url)}`
  );

  return res.json();
};
